/* DIREVULF — KwikPass account session (assets/dv-kp-session.js).
   KwikPass (mobile OTP) logins do not create a Shopify customer session on
   this store, so the theme cannot use Liquid's `customer`. This file is the
   one place that knows how to read a KwikPass login:

     DVAccount.token()   the KwikPass login token, or '' when signed out
     DVAccount.load()    Promise → { name, phone, email, addresses, orders… }
                         from the profile API (/apps/dv-profile/kp-me), which
                         verifies the token with GoKwik before returning data.
                         Cached for this browser tab; null when signed out.
     DVAccount.clear()   forget the cached account (used on logout)

   It also puts the signed-in customer's first name on the header's Profile
   link and points that link at the account page. */
(function () {
  'use strict';
  var KEY = 'dv:kp:me';
  var API = '/apps/dv-profile/kp-me';
  var inflight = null;

  function read(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function cookie(k) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  /* KwikPass keeps its login token under a key it names itself (currently
     ELRTOKEN; older installs used KWIKUSERTOKEN). Ask KwikPass for the name
     when its script is loaded, and fall back to the known names. */
  function tokenKeys() {
    var keys = [];
    try { if (typeof window.XGokwikUniToken === 'function') keys.push(window.XGokwikUniToken()); } catch (e) {}
    keys.push('ELRTOKEN', 'KWIKUSERTOKEN');
    return keys;
  }
  function token() {
    var t = '';
    var keys = tokenKeys();
    for (var i = 0; i < keys.length && !t; i++) { if (keys[i]) t = read(keys[i]) || cookie(keys[i]); }
    if (!t) return '';
    var logout = '';
    try { logout = sessionStorage.getItem('isLogout'); } catch (e) {}
    return logout === 'true' ? '' : t;
  }
  function cached() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      return c && c.t === token() ? c.me : null;
    } catch (e) { return null; }
  }
  function store(me) { try { sessionStorage.setItem(KEY, JSON.stringify({ t: token(), me: me })); } catch (e) {} }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  function load(fresh) {
    var t = token();
    if (!t) { clear(); return Promise.resolve(null); }
    if (!fresh) { var c = cached(); if (c) return Promise.resolve(c); }
    if (inflight) return inflight;
    inflight = fetch(API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ token: t })
    }).then(function (r) {
      if (r.status === 401) { clear(); return null; }
      if (!r.ok) throw new Error('account_unavailable');
      return r.json();
    }).then(function (me) {
      inflight = null;
      if (me) store(me);
      return me;
    }, function (e) { inflight = null; throw e; });
    return inflight;
  }

  window.DVAccount = { token: token, load: load, clear: clear };

  /* ---------- header: name on the Profile link ---------- */
  function first(me) {
    var n = (me && (me.firstName || me.name)) || '';
    return n.split(' ')[0];
  }
  function paintHeader(me) {
    var name = first(me);
    if (!name) return;
    var links = document.querySelectorAll('.header-tools a[href="/account"], .header-tools a[href^="/customer_authentication"]');
    Array.prototype.forEach.call(links, function (a) {
      a.setAttribute('href', '/pages/profile');
      a.setAttribute('aria-label', 'Your account, ' + name);
      var label = a.querySelector('span');
      if (label) label.textContent = name;
    });
    /* Phone menu: "Sign in / Create account" becomes the customer's name and
       a link to their account. */
    Array.prototype.forEach.call(document.querySelectorAll('.mobile-nav__account'), function (box) {
      var wrap = box.querySelector('div');
      if (!wrap || wrap.getAttribute('data-dv-me') === name) return;
      wrap.setAttribute('data-dv-me', name);
      wrap.textContent = '';
      var hi = document.createElement('a');
      hi.href = '/pages/profile';
      var strong = document.createElement('strong');
      strong.textContent = 'Hi, ' + name;
      hi.appendChild(strong);
      var acct = document.createElement('a');
      acct.href = '/pages/profile';
      acct.textContent = 'My account';
      wrap.appendChild(hi);
      wrap.appendChild(acct);
      var avatar = box.querySelector('.mobile-nav__avatar');
      if (avatar) { avatar.textContent = name.charAt(0).toUpperCase(); avatar.classList.add('is-initial'); }
    });
  }
  /* A login made in KwikPass's popup on any page: paint the name without a reload. */
  window.addEventListener('user-loggedin', function () {
    setTimeout(function () { clear(); load(true).then(paintHeader).catch(function () {}); }, 400);
  });
  if (token()) {
    var c = cached();
    if (c) paintHeader(c);
    else if (!document.querySelector('[data-dva]')) load().then(paintHeader).catch(function () {});
  }
  window.addEventListener('dv:account', function (e) { paintHeader(e.detail); });
})();
